import { useQuery } from '@tanstack/react-query';
import { Auth } from 'aws-amplify';

const fetchUserInfo = async () => {
  const response = await Auth.currentUserInfo();
  return response;
};

export const useQueryUserInfo = () => {
  const { data, isFetching, status, error } = useQuery({
    queryKey: ['/user'],
    queryFn: () => fetchUserInfo(),
    staleTime: 1000 * 60,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });
  return {
    userData: data,
    isFetching,
    status,
    error,
  };
};
